// CompaniesList/index.js
import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Paper, Grid, Typography, Button } from '@material-ui/core';
import {
  LibraryBooks as LibraryBooksIcon,
  DeleteOutline as DeleteOutlineIcon,
  Edit as EditIcon
} from '@material-ui/icons';

import EditPersonnelDialog from '../../containers/EditPersonnelDialog';
import CoursesForPersonnelDialog from '../../containers/CoursesForPersonnelDialog';
import DeletePersonnedDialog from '../../containers/DeletePersonnelDialog';
import SortByPropertyName from '../../mappers/sortByPropertyName';

import FancyDropDown from '../FancyDropDown';

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(2),
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(1)
  },
  personnelName: {
    fontSize: 18,
    fontWeight: 'normal',
    paddingTop: theme.spacing(1)
  },
  email: {
    paddingTop: theme.spacing(1)
  },
  coursesContainer: {
    // paddingTop: theme.spacing(2)
  },
  editDeleteContainer: {
    // paddingTop: theme.spacing(2)
  },
  editButton: {
    color: theme.palette.secondary.main
  },
  deleteButton: {
    color: theme.palette.danger.main
  },
  coursesButton: {
    color: theme.palette.secondary.main
  },
  dropDown: {
    width: 200,
    marginBottom: theme.spacing(3)
  }
}));

const SinglePersonnel = (props) => {
  const classes = useStyles();
  const {
    personnel,
    openCoursesForPersonnelDialog,
    handlePersonnelEditClick,
    handlDeletePersonnelDialog
  } = props;

 


  return (
    <React.Fragment>
      <Paper>
        <div className={classes.container}>
          <Grid container>
            <Grid item xs={6}>
              <div className={classes.companyDetails}>
                <Typography variant="h3" className={classes.personnelName}>
                  {personnel && `${personnel.firstName} ${personnel.lastName}`}
                </Typography>
                <Typography variant="subtitle1" className={classes.email}>
                  {personnel && personnel.email}
                </Typography>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.coursesContainer}>
                <Button
                  startIcon={<LibraryBooksIcon />}
                  className={classes.coursesButton}
                  onClick={() => openCoursesForPersonnelDialog(true, personnel)}
                >
                  Training
                </Button>
              </div>
            </Grid>
            <Grid item xs={3}>
              <div className={classes.editDeleteContainer}>
                <Button
                  startIcon={<EditIcon />}
                  className={classes.editButton}
                  onClick={() => handlePersonnelEditClick({ ...personnel })}
                >
                  Personnel Detail
                </Button>
                <Button
                  startIcon={<DeleteOutlineIcon />}
                  className={classes.deleteButton}
                  onClick={() =>
                    handlDeletePersonnelDialog(true, { ...personnel })
                  }
                >
                  Delete
                </Button>
              </div>
            </Grid>
          </Grid>
        </div>
      </Paper>
    </React.Fragment>
  );
};

function PersonnelsList(props) {
  const {
    fetchAllPersonnels,
    personnels,
    onPersonnelEditClick,
    branchId,
    onOpenCoursesForPersonnelDialog,
    onOpenDeletePersonnelDialog
  } = props;
  

  const useStyles = makeStyles((theme) => ({
    dropDown: {
      width: 200,
      marginBottom: theme.spacing(4)
    },
    companiesListContainer:{
      marginTop: theme.spacing(4)
    }
  }));

  const classes = useStyles();

  const items = [ {id:1, value:"Employees", name:"Employees"}, {id:2, value:"Non employees", name:"Non employees"}, {id:3, value: "All personnel", name: "All personnel"}]
  
  const [personnelType, setPersonnelListType] = React.useState(1);


  React.useEffect(() => {

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [personnelType]); 

  if (!personnels) {
    return null;
  }

  const handlePersonnelEditClick = (personnel) => {
    onPersonnelEditClick(personnel);
  };

  const openCoursesForPersonnelDialog = (open, personnel) => {
    onOpenCoursesForPersonnelDialog(open, personnel);
  };

  const handlDeletePersonnelDialog = (open, personnel) => {
    onOpenDeletePersonnelDialog(open, personnel);
  };

  let sortedPersonnels = SortByPropertyName(personnels, 'firstName');

  const filteredPersonnel  =  personnelType === 3 ?  sortedPersonnels : sortedPersonnels.filter(x=> x.personnelType === personnelType);


  const handleDropdownChange = (e) => {
    setPersonnelListType(e.target.value);
  }

  return (
    <React.Fragment>

      <EditPersonnelDialog />
      <CoursesForPersonnelDialog />
      <DeletePersonnedDialog />

      <FancyDropDown
                htmlId="documentDropdown"
                label="Personnel Type"
                margin="normal"
                value={personnelType}
                handleChange={handleDropdownChange
                }
                items={items}
                dropDownWidth="30%"
                className={classes.dropDown}
                valueField="id"
                displayField="value"
                required={true}
              />



      <div className={classes.companiesListContainer}>

 

        {filteredPersonnel &&
          filteredPersonnel.map((personnel) => {
            return (
              <SinglePersonnel
                personnel={personnel}
                key={personnel.id}
                handlePersonnelEditClick={handlePersonnelEditClick}
                openCoursesForPersonnelDialog={openCoursesForPersonnelDialog}
                handlDeletePersonnelDialog={handlDeletePersonnelDialog}
              />
            );
          })}
      </div>
    </React.Fragment>
  );
}

export default PersonnelsList;
